import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IAgSachbearbeiterListResponseDto, IManagerProfileAuftragResponseDto } from "../types/Types";
import { PaginatorDto } from "../pages/eigeneauftraege/EigeneAuftraegeListe";

/**
 * @author mb
 */
export const MiscAPI = createApi({
    reducerPath: "MiscAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "misc",
            credentials: 'include'
        }),
    tagTypes: ['MiscAPI'], // for caching
    endpoints: (builder) => ({
        getToastMessages: builder.mutation<any[], void >(
            {
                query: (dto) => ({
                    url: '/toast-messages',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),
        markToastMessageAsRead: builder.mutation<void, string >(
            {
                query: (uid) => ({
                    url: '/toast-messages/' + uid + '/marked-as-read',
                    method: 'get',
                    credentials: 'include'
                })
            }
        ),

    })
});

export const {

    useGetToastMessagesMutation,
    useMarkToastMessageAsReadMutation,

} = MiscAPI;
